import config from 'config';
import { http_client } from './api';

const getList = async (query) => {
  return http_client.get(config.apiUrl + 'examarch', query).then((response) => {
    return response.data;
  });
};
const getListArchive = async (query = null) => {
  return http_client.get(config.apiUrl + 'examarch/archive', query).then((response) => {
    return response.data;
  });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'examarch', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'examarch/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'examarch/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'examarch/' + id).then((response) => {
    return response.data;
  });
};

const getHistory = async (id) => {
  return http_client.get(config.apiUrl + 'examarch/' + id + '/history').then((response) => {
    return response.data;
  });
};

const getPreview = async (id) => {
  return http_client.get(config.apiUrl + 'examarch/' + id + '/preview').then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'examarch/' + id + '/status', data).then((response) => {
    return response.data;
  });
};

const getSession = async (id, sessionId) => {
  return http_client.get(config.apiUrl + 'examarch/' + id + '/session/' + sessionId).then((response) => {
    return response.data;
  });
};

const sessionScore = async (id, sessionId) => {
  return http_client.post(config.apiUrl + 'examarch/' + id + '/session/' + sessionId).then((response) => {
    return response.data;
  });
};

const storeQuestionScore = async (id, sessionId, questionId, data) => {
  return http_client.post(config.apiUrl + 'examarch/' + id + '/session/' + sessionId + '/' + questionId, data).then((response) => {
    return response.data;
  });
};

const getQuestionList = async (id, query = null) => {
  return http_client.get(config.apiUrl + 'examarch/' + id + '/question', query).then((response) => {
    return response.data;
  });
};

const storeQuestion = async (id, data) => {
  return http_client.post(config.apiUrl + 'examarch/' + id + '/question', data).then((response) => {
    return response.data;
  });
};

const getQuestion = async (id, questionId) => {
  return http_client.get(config.apiUrl + 'examarch/' + id + '/question/' + questionId).then((response) => {
    return response.data;
  });
};

const updateQuestion = async (id, questionId, data) => {
  return http_client.post(config.apiUrl + 'examarch/' + id + '/question/' + questionId, data).then((response) => {
    return response.data;
  });
};

const destroyQuestion = async (id, questionId) => {
  return http_client.delete(config.apiUrl + 'examarch/' + id + '/question/' + questionId).then((response) => {
    return response.data;
  });
};

const getTags = async () => {
  return http_client.get(config.apiUrl + 'examarch/tag').then((response) => {
    return response.data;
  });
};

const addStudent = async (id, data) => {
  return http_client.post(config.apiUrl + 'examarch/' + id + '/student', data).then((response) => {
    return response.data;
  });
};

const removeStudent = async (id, data) => {
  return http_client.patch(config.apiUrl + 'examarch/' + id + '/student', data).then((response) => {
    return response.data;
  });
};

const getRatings = async (id, query = null) => {
  return http_client.get(config.apiUrl + 'examarch/' + id + '/ratings', query).then((response) => {
    return response.data;
  });
};

const ExamArchService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  getHistory,
  getPreview,
  changeStatus,
  getSession,
  sessionScore,
  storeQuestionScore,
  getQuestionList,
  storeQuestion,
  getQuestion,
  updateQuestion,
  destroyQuestion,
  getTags,
  addStudent,
  removeStudent,
  getRatings
};

export default ExamArchService;
